// extracted by mini-css-extract-plugin
export default {"label":"ValidationSuccess_label__RrQwF","value":"ValidationSuccess_value__oBNfu","container":"ValidationSuccess_container__6r4N8"};